/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import axios from 'axios'
import Swal from 'sweetalert2'
import firebase from '../../../firebase/FirebaseConfig'

const DeviceNoteDetailModal = ({
  selectedDeviceNote,
  setSelectedDeviceNote,
  showModalDeviceNoteDetail,
  setShowModalDeviceNoteDetail,
  trigger,
  setTrigger,
}) => {
  const closeModal = () => {
    setShowModalDeviceNoteDetail(false)
  }

  const deleteDeviceNote = async () => {
    const db = firebase.firestore()
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this device note!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          Swal.fire({
            title: 'Loading...',
            text: 'Please wait',
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading()
            },
          })

          await db.collection('deviceNotes').doc(selectedDeviceNote.docId).delete()
          setTrigger(!trigger)
          Swal.fire({
            icon: 'success',
            title: 'Deleted!',
            text: 'Your device note has been deleted.',
          })

          setSelectedDeviceNote(null)
          setShowModalDeviceNoteDetail(false)
        } catch (error) {
          console.error('Error deleting device note:', error)
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'There was an error deleting the device note.',
          })
        }
      }
    })
  }

  return (
    <>
      <Modal show={showModalDeviceNoteDetail} onHide={() => closeModal()} size='lg'>
        <Modal.Header>
          <Modal.Title>
            <h3 className='fw-600'>Device note</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='p-2'>
            <div className='row'>
              <div className='col-6 mb-5'>
                <label className='form-label'>Device Name</label>
                <input
                  type='text'
                  className='form-control'
                  value={selectedDeviceNote?.deviceName}
                />
              </div>
              <div className='col-6 mb-5'>
                <label className='form-label'>Device ID</label>
                <input type='text' className='form-control' value={selectedDeviceNote?.deviceId} />
              </div>

              <div className='col-12 mb-5'>
                <label className='form-label'>Note Header</label>
                <input type='text' className='form-control' value={selectedDeviceNote?.note} />
              </div>

              <div className='col-12 mb-5'>
                <label className='form-label'>Note</label>
                <input type='text' className='form-control' value={selectedDeviceNote?.note} />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className='btn btn-danger' onClick={() => deleteDeviceNote()}>
            Delete
          </button>
          <button className='btn btn-secondary' onClick={() => closeModal()}>
            ปิด
          </button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export {DeviceNoteDetailModal}
